"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAccountSpecifics = void 0;
const invariant_1 = __importDefault(require("invariant"));
const account_1 = require("../../account");
const currencies_1 = require("../../currencies");
function formatAccountSpecifics(account) {
    var _a, _b, _c, _d, _e;
    const { cardanoResources } = account;
    (0, invariant_1.default)(cardanoResources, "cardano account expected");
    const unit = (0, account_1.getAccountUnit)(account);
    const formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true,
    };
    let str = " ";
    if ((_a = cardanoResources === null || cardanoResources === void 0 ? void 0 : cardanoResources.delegation) === null || _a === void 0 ? void 0 : _a.poolId) {
        str += (0, currencies_1.formatCurrencyUnit)(unit, account.balance, formatConfig) + " delegated to ";
    }
    if ((_b = cardanoResources.delegation) === null || _b === void 0 ? void 0 : _b.name)
        str += cardanoResources.delegation.name + " ";
    if ((_c = cardanoResources.delegation) === null || _c === void 0 ? void 0 : _c.ticker)
        str += "(" + cardanoResources.delegation.ticker + ") ";
    if ((_d = cardanoResources.delegation) === null || _d === void 0 ? void 0 : _d.poolId)
        str += cardanoResources.delegation.poolId + ". ";
    if ((_e = cardanoResources.delegation) === null || _e === void 0 ? void 0 : _e.rewards)
        str +=
            "Total " +
                (0, currencies_1.formatCurrencyUnit)(unit, cardanoResources.delegation.rewards, formatConfig) +
                " rewards available.";
    return str;
}
exports.formatAccountSpecifics = formatAccountSpecifics;
exports.default = {
    formatAccountSpecifics,
};
//# sourceMappingURL=account.js.map